<template>
  <div :class="[$attrs['class'], 'section']">
    <slot />
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/button/mixin.scss";
@import "../ArtworkQualityConfigPanel.scss";

.section {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: $crafterpay-gray-modern-50;
  padding: 9px 12px 16px;

  &:empty {
    display: none;
  }

  @include with-quality-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
  }
}
</style>
